import { OrderState } from "../slices/orderFormSlice"

type RootState = {
  order: OrderState
}

export const selectSplitPaymentTotal = (state: RootState) =>
  state.order.splitPayments.reduce((sum, p) => sum + (Number(p.amount) || 0), 0)

export const selectSplitPaymentDifference = (state: RootState) => {
  const totalAmount = state.order.totalAmount

  const splitTotal = selectSplitPaymentTotal(state)

  return Number((totalAmount - splitTotal).toFixed(2))
}

export const selectIsSplitPaymentValid = (state: RootState) => {
  const totalAmount = state.order.totalAmount
  const splitTotal = selectSplitPaymentTotal(state)

  return Math.abs(splitTotal - totalAmount) < 0.01
}
